import { MiReportSource } from 'src/graphql';
import { MiReportSourceForDisplay } from 'src/types';

export const getReadableReportSource = (
  miReportSource?: MiReportSource,
): MiReportSourceForDisplay | string => {
  switch (miReportSource) {
    case MiReportSource.Phone:
      return MiReportSourceForDisplay.PHONE;
    case MiReportSource.Email:
      return MiReportSourceForDisplay.EMAIL;
    case MiReportSource.Postal:
      return MiReportSourceForDisplay.POSTAL;
    case MiReportSource.Box:
      return MiReportSourceForDisplay.BOX;
    case MiReportSource.FaceToFace:
      return MiReportSourceForDisplay.FACE_TO_FACE;
    case MiReportSource.CollaborationApp:
      return MiReportSourceForDisplay.COLLABORATION_APP;
    case MiReportSource.VideoConferencing:
      return MiReportSourceForDisplay.VIDEO_CONFERENCING;
    case MiReportSource.Other:
      return MiReportSourceForDisplay.OTHER;
    default:
      return MiReportSourceForDisplay.UNSPECIFIED;
  }
};
